import {Department, EventDepartment, ITraveler, DEPARTMENTS} from '../data/interfaces';

export function shouldShowShipOnlyMarker(
  department: Department | EventDepartment,
  traveler: Pick<ITraveler, 'projectCrews'> | null
): boolean {
  return (department === DEPARTMENTS.assembly || department === DEPARTMENTS.production)
    && !!traveler
    && !traveler.projectCrews.some((projectCrew) =>
      projectCrew.toLowerCase().includes('installation')
    );
}
